// extracted by mini-css-extract-plugin
export default {"horizontalSeparationLine":"SeparationLine_horizontalSeparationLine__JamMO","verticalSeparationLine":"SeparationLine_verticalSeparationLine__+ma90"};